import { render, staticRenderFns } from "./MilestoneTable.vue?vue&type=template&id=2a5b8572&"
import script from "./MilestoneTable.vue?vue&type=script&lang=js&"
export * from "./MilestoneTable.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports